import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL, envConfig } from "../config";
import { Email, EmailLog } from "../types/email";

export const emailsApi = createApi({
  reducerPath: "emailsApi",
  baseQuery: fetchBaseQuery({
    credentials: "include",
    baseUrl: BASE_URL + "emails",
    prepareHeaders: (headers) => {
      headers.set("api-key", `${envConfig.API_KEY}`);
      return headers;
    },
  }),
  tagTypes: ["Emails"],
  endpoints: (builder) => ({
    getEmails: builder.query<EmailLog[], string>({
      query: () => `/`,
      providesTags: ["Emails"],
    }),
    getEmailsByRefNo: builder.query<EmailLog[], string>({
      query: (refNo) => `/refno/${encodeURIComponent(refNo)}`,
      providesTags: (_r, _e, refNo) => [{ type: "Emails", id: refNo }],
    }),
    getEmailsByRecipient: builder.query<EmailLog[], string>({
      query: (to) => `/recipient/${encodeURIComponent(to)}`,
      providesTags: (_r, _e, to) => [{ type: "Emails", id: to }],
    }),
    sendEmail: builder.mutation<{ message: string }, Email>({
      query: (email) => ({
        url: `/`,
        method: "POST",
        body: email,
      }),
      invalidatesTags: ["Emails"],
    }),
    deleteEmail: builder.mutation<void, string>({
      query: (id) => ({ url: `/${id}`, method: "DELETE" }),
      invalidatesTags: ["Emails"],
    }),
  }),
});

export const {
  useGetEmailsQuery,
  useGetEmailsByRefNoQuery,
  useGetEmailsByRecipientQuery,
  useSendEmailMutation,
  useDeleteEmailMutation,
} = emailsApi;
